export default __webpack_public_path__ + "static/media/manager.fb3cb4fa.png";